import { twMerge as i } from "tailwind-merge";
const r = "group flex items-center justify-center focus-visible:outline-brand-primary rounded-lg h-3 px-[9px] py-4 [&>svg]:h-3.5 [&>svg]:w-3.5 cursor-pointer", n = (t) => i(
  "main-transition-colors",
  t ? "stroke-text-secondary" : "stroke-text-primary group-hover:stroke-brand-primary"
), a = (t) => i(
  "main-transition-colors",
  t ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary"
), m = (t) => i(
  "main-transition-colors",
  t ? "text-text-secondary" : "text-text-primary hover:text-brand-primary"
), l = "#000000", s = "15px", p = "#ffffff", o = "1rem", g = "8px", c = {
  marginTop: 0,
  marginBottom: 0
}, d = {
  2: {
    marginTop: "0.83em",
    marginBottom: "0.83em",
    fontSize: "1.5em",
    lineHeight: "normal",
    fontFamily: "inherit",
    fontWeight: "bold"
  },
  3: {
    marginTop: "1em",
    marginBottom: "1em",
    fontSize: "1.17em",
    lineHeight: "normal",
    fontFamily: "inherit",
    fontWeight: "bold"
  },
  4: {
    marginTop: "1.33em",
    marginBottom: "1.33em",
    lineHeight: "normal",
    fontFamily: "inherit",
    fontWeight: "bold",
    fontSize: "1em"
  }
}, h = {
  marginTop: o,
  marginBottom: o,
  paddingLeft: "40px"
}, x = {
  hoverOpenDelay: 900,
  popoverClassName: "px-2 py-1 shadow-md [--anchor-gap:5px] z-[9999]"
}, T = {
  display: "table",
  clear: "both",
  textAlign: "center",
  minWidth: "50px",
  maxWidth: "100%",
  margin: ".9em auto"
}, f = "@media (max-width: 600px) { .is-mobile-full-width figure { width: 100% !important; } }", S = "@media (max-width: 600px) { .is-mobile-full-width img { width: 100% !important; max-width: 100% !important; } }", L = (t) => ({
  display: "table",
  float: "right",
  clear: "both",
  textAlign: "center",
  minWidth: "50px",
  maxWidth: "100%",
  margin: t ? `${o} 0 .9em 1.5em` : "0 0 .9em 1.5em"
}), E = {
  display: "block",
  margin: "0 auto",
  minWidth: "100%",
  maxWidth: "100%"
}, _ = {
  display: "table-caption",
  captionSide: "bottom",
  wordBreak: "break-word",
  textAlign: "center",
  color: "rgb(var(--text-primary))",
  backgroundColor: "rgb(var(--background-primary))",
  padding: ".6em",
  fontSize: ".75em",
  outlineOffset: "-1px"
};
export {
  E as BLOCK_IMAGE_STYLES,
  p as DEFAULT_BG_COLOR,
  l as DEFAULT_COLOR,
  s as DEFAULT_FONT_SIZE,
  g as EDITOR_PADDING,
  _ as FIGCAPTION_STYLES,
  T as FIGURE_CENTERED_STYLES,
  f as FIGURE_MOBILE_FULL_WIDTH_STYLES,
  d as HEADING_STYLES,
  S as IMAGE_MOBILE_FULL_WIDTH_STYLES,
  h as LIST_STYLES,
  c as PARAGRAPH_STYLES,
  r as TOOLBAR_BUTTON_CLASSNAMES,
  x as TOOLTIP_STYLES,
  L as getFigureRightStyles,
  m as getToolbarCaptionClassName,
  n as getToolbarIconClassName,
  a as getToolbarIconFillClassName
};
